import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — riporta in cima la finestra a ogni cambio di pathname.
 * Evita che le pagine si aprano "a metà scroll" quando l'utente naviga
 * da una pagina con scroll precedente.
 * Rispetta hash anchor (#section) — se presenti, non interrompe il
 * comportamento nativo di scroll-to-anchor.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // lascia gestire al browser l'anchor scroll
    // Riporta in cima con scroll istantaneo (no jank durante page transition)
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
